module.exports = __webpack_public_path__ + "media/customizations/regencyatmilestoneranch/logo-new-5eaa1ad03c3b2157655fed60f7ed84c0.png";